import React, { FC, memo, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { resolver } from './resolver'
import { Modal } from '../../../../../../../components/Dashboard/Modal'
import { useRest } from '../../../../../../../components/Context'
import { InputField } from '../../../../../../../components/Dashboard/InputField'
import { InputSelect } from '../../../../../../../components/Dashboard/InputSelect'
import { CURRENCIES } from '../../../../../../../constants/currencies'
import { OPERATIONS } from '../../../../../../../constants/operations'
import { Loader } from '../../../../../../../components/Loader'

const useStyles = makeStyles((theme: Theme) => ({
  body: {
    height: 188,
    paddingTop: theme.spacing(1),
  },
  input: {
    height: 91,
    '& label': {
      paddingBottom: theme.spacing(0.5),
    },
    '&>p': {
      lineHeight: '91px',
    },
  },
  name: {
    '& :nth-child(2)': {
      paddingLeft: theme.spacing(2),
    },
  },
}))

interface IAdjust {
  isOpen: boolean
  modalClose: () => void
}

const AdjustPopup: FC<IAdjust> = ({ isOpen, modalClose }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
    resolver,
  })
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [assetId, setAssetId] = useState<number | undefined>()
  const defaultSelectedCurrency = CURRENCIES[0].value
  const defaultSelectedOperation = OPERATIONS[0].value
  // eslint-disable-next-line
  const [selectedOperation, setSelectedOperation] = useState<string>('')
  // eslint-disable-next-line
  const [selectedCurrency, setSelectedCurrency] = useState<string>('')
  // eslint-disable-next-line
  const [inputedAdress, setInputedAddress] = useState<string>('')
  const { handleSubmit, watch, reset } = formMethods

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === 'operation') setSelectedOperation(value?.[name])
      if (name === 'currency') setSelectedCurrency(value?.[name])
      if (name === 'address') setInputedAddress(value?.[name])
    })
    return () => subscription.unsubscribe()
    // eslint-disable-next-line
  }, [watch])

  const onSubmit = useCallback(
    // eslint-disable-next-line
    (data: any) => {
      setLoading(true)

      rxiosAuth.put(``, data).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setLoading(false)
        },
        (error) => {
          setLoading(false)
          toast.error(error.response.data.message)
        },
        () => {
          setLoading(false)
          toast.success('Status was edited')
          modalClose()
          formMethods.reset()
        },
      )
    },
    // eslint-disable-next-line
    [assetId, rxiosAuth],
  )

  useEffect(() => {
    if (!isOpen) {
      setLoading(false)
      setTimeout(reset, 300)
    }
  }, [isOpen, reset])

  return (
    <Modal title="Adjust" isOpen={isOpen} modalClose={modalClose} isSubmit onSubmit={handleSubmit(onSubmit)}>
      {loading && <Loader />}
      <FormProvider {...formMethods}>
        <Grid container spacing={3} className={classes.body}>
          <Grid item xs={6} className={classes.input}>
            <InputSelect
              inputName="operation"
              labelName={'Operation'}
              width={'100%'}
              enums={OPERATIONS}
              defaultValue={defaultSelectedOperation}
            />
          </Grid>

          <Grid item xs={6} className={classes.input}>
            <Typography className={classes.name}>
              <Typography component={'span'}>User:</Typography>
              <Typography component={'span'}>Jane Smith</Typography>
            </Typography>
          </Grid>

          <Grid item xs={6} className={classes.input}>
            <InputSelect
              inputName="currency"
              labelName={'Currency'}
              width={'100%'}
              enums={CURRENCIES}
              defaultValue={defaultSelectedCurrency}
            />
          </Grid>

          <Grid item xs={6} className={classes.input}>
            <InputField inputName="address" labelName={'Address Suffix'} inputType="text" width={'100%'} />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}

export const MemoAdjustPopup = memo(AdjustPopup)
